<template>
    <div class="erm_wrapper">
        <div class="template_settings_header">
            <div class="template_setting">
                <div class="erm_flex" style="margin-bottom: 20px;">
                    <div class="choose_color">
                        <el-tooltip class="box-item"
                            content="Pick the main color for your menu, affecting key elements like headings and buttons."
                            placement="top-start">
                            <div class="demonstration">
                                Choose Primary Color
                                <el-icon><InfoFilled /></el-icon>
                            </div>
                        </el-tooltip>
                        <el-color-picker v-model="settings.primary_color" />
                    </div>
                    <div class="choose_color">
                        <el-tooltip class="box-item"
                            content="Set the text color for your menu items. Ensure it contrasts well with the background for readability."
                            placement="top-start">
                            <div class="demonstration">
                                Choose Font Color
                                <el-icon><InfoFilled /></el-icon>
                            </div>
                        </el-tooltip>
                        <el-color-picker v-model="settings.font_color" />
                    </div>
                    <div class="choose_color">
                        <el-tooltip class="box-item"
                            content="Choose an accent color for highlighting important elements in your menu."
                            placement="top-start">
                            <div class="demonstration">
                                Choose Background Color
                                <el-icon><InfoFilled /></el-icon>
                            </div>
                        </el-tooltip>
                        <el-color-picker v-model="settings.background_color" />
                    </div>
                    <div class="choose_color">
                        <el-tooltip class="box-item"
                            content="Choose an accent color for highlighting important elements in your menu."
                            placement="top-start">
                            <div class="demonstration">
                                Choose Secondary Color
                                <el-icon><InfoFilled /></el-icon>
                            </div>
                        </el-tooltip>
                        <el-color-picker v-model="settings.secondary_color" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    props: {
        settings: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            loading: false,
            mode: 'settings',
            rest_api: window.RestaurantMenuMangeData.rest_api,
        }
    },
    methods: {

    },
}
</script>

<style lang="scss">
.template_settings_header,
.template_settings_body {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 8px;
}

.settings_item {
    margin-bottom: 20px;
    .demonstration {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 10px;
    }
    .el-input__wrapper {
        height: 38px;
    }
}

.template_setting {
    .choose_color {
        width: calc(25% - 15px);
        .demonstration {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        .enable_details_btn {
            margin-top: 8px;
        }
        .el-color-picker {
            width: 100% !important;
        }
        .el-color-picker__trigger {
            width: 100% !important;
        }

        .el-select__wrapper {
            width: 100% !important;
            height: 38px;
        }
    }
}

.template_settings_top_navbar {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    text-align: center;

    .erm_left_navbar {
        display: flex;
        gap: 20px;
        align-items: center;

        .erm_shortcode {
            a {
                background: #e5e6e899;
                padding: 10px 12px;
                border-radius: 8px;
                font-size: 16px;
                color: #3C434A;
            }

        }

        .erm_custom_mode {
            background-color: #e5e6e899;
            display: flex;
            gap: 10px;
            align-items: center;
            font-size: 16px;
            padding: 6px 6px;
            border-radius: 8px;

            .erm_mode_item {
                color: #606266;
                border-radius: 6px;
                padding: 6px 12px;
            }

            .active {
                background-color: #fff;
                color: #3C434A;
                border-radius: 6px;
                padding: 6px 12px;
            }
        }
    }

    .erm_right_navbar {
        button {
            font-size: 16px;
            border: 1px solid #017EF3;
            background: #017EF3;
            color: #fff;
            padding: 8px 10px;
            border-radius: 8px;
            cursor: pointer;
            transition: all .3s;

            &:hover {
                background: #0165C2;
            }
        }
    }
}
</style>